import React from 'react'
import { ProfileData } from '../../../../helpers/models/Models';
import SecHeading from '../../../../constants/SecHeading';
import { CiLocationOn } from "react-icons/ci";
import { Grid } from '@mui/material';
import InputTextBox from '../../../../constants/InputTextBox';

interface ProfileDataDetailsProps {
    ProfileDataDetails: ProfileData | null;
}
const AddressView: React.FC<ProfileDataDetailsProps> = ({ ProfileDataDetails }) => {
    return (
        <div>
            <SecHeading icon={<CiLocationOn />} type='add' label='Address' />
            <p className="border-t border-slate-300 pt-2 border-dashed"></p>
            <Grid container columnSpacing={3} rowSpacing={1}>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Province:' name='spouses_name' type='text' value={ProfileDataDetails?.province_name || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='District:' name='spouses_name' type='text' value={ProfileDataDetails?.district_name || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Municipality:' name='spouses_name' type='text' value={ProfileDataDetails?.municipality_name || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Ward No.:' name='spouses_name' type='text' value={ProfileDataDetails?.ward_no || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Address:' name='spouses_name' type='text' value={ProfileDataDetails?.add_eng || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Address(Nepali):' name='spouses_name' type='text' value={ProfileDataDetails?.add_nep || ""} disabled />
                </Grid>
            </Grid>
        </div>
    )
}

export default AddressView